import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetAvailableCouponList = async (params) => {
    const url = `${BaseUrl}/CouponCode/GetAvailableCouponList`;
    const res = await postApiWithAuthorization(url, params);

    return res;
};

